export interface StatoRichiesta {
    id: number;
    descrizione: string;
}

export enum StatoRichiestaEnum {
  IN_PREPARAZIONE  = "IN PREPARAZIONE",
  PRESENTATA  = "PRESENTATA",
  FINANZIATA  = "FINANZIATA",
  RENDICONTATA  = "RENDICONTATA",
  CHIUSA  = "CHIUSA",
  ELIMINATA  = "ELIMINATA",
}
